<template>
    <div class="relative" ref="dropdownContainer">
        <button
            @click="toggleDropdown"
            class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
        >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
            </svg>
            {{ $t('files.context_menu.add_to_scene') }}
            <svg class="w-4 h-4 ml-auto" :class="{ 'rotate-180': isOpen }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
        </button>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <div
                v-if="isOpen"
                class="absolute left-2 z-10 mt-1 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
                @click.stop
            >
                <div class="py-1 max-h-64 overflow-y-auto">
                    <div v-if="folders.length === 0" class="px-4 py-2 text-sm text-gray-500 text-center">
                        {{ $t('files.context_menu.no_scenes') }}
                    </div>

                    <button
                        v-for="folder in availableFolders"
                        :key="folder.id"
                        @click="selectScene(folder)"
                        class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-3"
                    >
                        <span class="inline-flex items-center gap-x-1.5 p-1 rounded-full bg-gray-100 text-xs font-medium text-gray-600">
                            <svg class="size-1.5" :style="{fill: folder.color}" viewBox="0 0 6 6" aria-hidden="true">
                              <circle cx="3" cy="3" r="3" />
                            </svg>
                        </span>
                        <div class="flex-1 min-w-0">
                            <div class="font-medium truncate">{{ folder.title }}</div>
                            <div v-if="folder.description" class="text-xs text-gray-500 truncate">{{ folder.description }}</div>
                        </div>
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Folder } from '@/types/GalleryType';
import { Photo } from '@/types/PhotoType';

export default defineComponent({
    name: 'SceneDropdownComponent',

    props: {
        folders: {
            type: Array as () => Folder[],
            default: () => []
        },
        photo: {
            type: Object as () => Photo,
            required: true
        }
    },

    emits: ['scene-selected'],

    data() {
        return {
            isOpen: false
        };
    },

    computed: {
        availableFolders(): any[] {
            // Фільтруємо сцени, де фото ще немає
            const folders = this.folders as any[];
            const photoFolders = this.photo?.folders || [];
            console.log('Photo folders:', photoFolders.map((pf: any) => pf.id));
            console.log('Current photo:', this.photo);
            const filtered = folders.filter((folder: any) => {
                return !photoFolders.some((photoFolder: any) => photoFolder.id === folder.id);
            });
            console.log('Available folders for photo:', this.photo?.id, 'folders:', filtered.map(f => f.title));
            return filtered;
        }
    },

    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },

        selectScene(folder: Folder) {
            this.$emit('scene-selected', {
                photo: this.photo,
                folder: folder
            });
            this.isOpen = false;
        },

        handleClickOutside(event: MouseEvent) {
            const dropdownContainer = this.$refs.dropdownContainer as HTMLElement;
            if (dropdownContainer && !dropdownContainer.contains(event.target as Node)) {
                this.isOpen = false;
            }
        }
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },

    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }
});
</script>

<style scoped>
.rotate-180 {
    transform: rotate(180deg);
}
</style>
